import { FormFieldTypes } from "../../../../../../data/formFieldType";

export const DuplicateCriteriaData = {
  name: "DuplicateCriteriaData",
  initialState: {
    channel: null,
    criteriaName: null,
  },
  formFields: [
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3 w-250",
      },
    },
    {
      id: "criteriaName",
      lable: "Criteria Name",
      Field_Name: "Criteria Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "criteriaName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-lg-12 mb-3 pr-0",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
